import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";
import { prepareFeature } from "@rf-helper/property/prepare-feature";

export const prepareDetailPropertyCardFeatures = (
  property: IPropertyDetailsResponse
) => {
  return prepareFeature({
    bathrooms: property?.bathrooms ?? null,
    halfBathrooms: property?.half_bathrooms ?? null,
    bedrooms: property?.bedrooms ?? null,
    floorLevel: property?.floor_level ?? null,
    floorsTotal: property?.floors_total ?? null,
    sqmLand: property?.sqm_land ?? null,
    sqmConstruction: property?.sqm_construction ?? null,
    pumps: property?.pumps ?? null,
    parkingSpots: property?.parking_spots ?? null
  });
};
